module.exports = __webpack_public_path__ + "img/2.519860f3.png";